export default __webpack_public_path__ + "static/media/steps.50ce0b29.svg";